export default __webpack_public_path__ + "./logo.831bdb2e3923be23e2093a0a9caa60e4.png";